import { render, staticRenderFns } from "./mt-radio-button-group.vue?vue&type=template&id=e6298c9c&"
import script from "./mt-radio-button-group.vue?vue&type=script&lang=js&"
export * from "./mt-radio-button-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports